import { c as _c } from "react/compiler-runtime";
import { subscribeWsReconnected } from '@src/lib/wsConnectionStatus';
import { useEffect, useRef } from 'react';

/**
 * Run `onReconnected` each time the shared GraphQL WebSocket reconnects after a drop.
 * Subscriptions resume on their own, but anything published while the socket was down
 * is lost, so a live view uses this to re-read its data.
 */
export function useWsReconnected(onReconnected) {
  const $ = _c(5);
  const callbackRef = useRef(onReconnected);
  let t0;
  let t1;
  if ($[0] !== onReconnected) {
    t0 = () => {
      callbackRef.current = onReconnected;
    };
    t1 = [onReconnected];
    $[0] = onReconnected;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => subscribeWsReconnected(() => callbackRef.current());
    t3 = [];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
}